//https://docs.pmnd.rs/jotai/api/utils#atom-with-storage
//for persistence only need to change from atom to atomWithStorage here and provide a key for storage. Don't need to change anywhere else.
import { atomWithStorage } from 'jotai/utils'

//https://docs.pmnd.rs/jotai/guides/persistence
export const darkThemeAtom = atomWithStorage('darkTheme', true)

